import { BASE_URL_API } from '@constants/base';
import { get } from '@utils/ajax';

/**
 * Companies Service
 * Handles all company-related API calls
 */
const companiesService = (() => {
    // Get company list
    const getCompanyList = async params => {
        try {
            const response = await get(`${BASE_URL_API}/main/warehouseCompany/list.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        getCompanyList
    };
})();

export default companiesService;
